import axios from 'axios'
import interceptorSetup from './interceptors'

import * as auth from './auth'
import * as user from './user'
import * as account from './account'
import * as masterDataDriver from './masterDataDriver'
import * as masterDataTransport from './masterDataTransport'
import * as masterDataUserAdmin from './masterDataUserAdmin'
import * as autocomplete from './autocomplete'
import * as order from './order'
import * as uploads from './uploads'
import * as schedule from './schedule'
import * as transactions from './transactions'
import * as masterData from './masterData'
import * as notifications from './notifications'
import * as shippingProblem from './shippingProblem'
import * as report from './report'

if (process.env.VUE_APP_API_TARGET === 'mock') {
  require('../mock-services') // import mock adapter if env is mock
}

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
interceptorSetup()

export {
  auth,
  user,
  account,
  masterData,
  masterDataDriver,
  masterDataTransport,
  masterDataUserAdmin,
  autocomplete,
  order,
  uploads,
  schedule,
  transactions,
  notifications,
  shippingProblem,
  report
}
